export function createEditHandlers({
	disabled,
	isSaving,
	required,
	recordId,
	row,
	fieldName,
	isMulti,
	formatOutput,
	getOptionValue,
	valueToSelectValue,
	value,
	onSave,
	selectedValue,
	setErrorText,
	setIsEditing,
	setIsEditingState,
	setSelectedValue,
	isMountedRef,
	setIsSaving,
	abortRef,
	clearPersistedState,
	newOptionDefaults,
	onCreateOption,
	setDynamicOptions,
}) {
	const beginEdit = () => {
		if (disabled || isSaving) return;
		setErrorText("");
		setIsEditing(true);
	};

	const cancelEdit = () => {
		clearPersistedState();
		setSelectedValue(valueToSelectValue(value));
		setErrorText("");
		setIsEditingState(false);
	};

	const defaultFormatter = (selected) => {
		if (!selected) return null;
		if (isMulti) {
			return Array.isArray(selected) ? selected.map((s) => getOptionValue(s)) : [];
		}
		return getOptionValue(selected);
	};

	const persistChange = async () => {
		if (disabled || isSaving) return;
		setErrorText("");

		if (required && !selectedValue) {
			setErrorText("Este campo es requerido");
			return;
		}

		const outputFormatter = formatOutput || defaultFormatter;
		const newValue = outputFormatter(selectedValue);

		if (!recordId || typeof onSave !== "function") {
			cancelEdit();
			return;
		}

		clearPersistedState();
		setIsEditingState(false);

		const controller = new AbortController();
		abortRef.current = controller;

		try {
			setIsSaving(true);
			await onSave({
				recordId,
				originalRow: row?.original,
				fieldName,
				newValue,
				selectedValue,
				signal: controller.signal,
			});
		} catch (err) {
			if (!isMountedRef.current) return;
			if (err?.name !== "CanceledError" && err?.name !== "AbortError") {
				setErrorText(err?.message || "No se pudo guardar");
			}
		} finally {
			if (isMountedRef.current) setIsSaving(false);
			abortRef.current = null;
		}
	};

	const handleKeyDown = (event) => {
		if (event.key === "Escape") {
			event.preventDefault();
			cancelEdit();
		}
	};

	const handleCreateOption = (inputValue) => {
		const newOption = {
			value: inputValue,
			label: inputValue,
			isNew: true,
			...newOptionDefaults,
		};

		setDynamicOptions((prev) => [...prev, newOption]);

		if (isMulti) {
			setSelectedValue((prev) => [...(prev || []), newOption]);
		} else {
			setSelectedValue(newOption);
		}

		if (onCreateOption) {
			onCreateOption(inputValue, newOption);
		}
	};

	return {
		beginEdit,
		cancelEdit,
		persistChange,
		handleKeyDown,
		handleCreateOption,
	};
}
